@import '../../../utils/global.module.less';

.lockedInput {
    filter: grayscale(1);
    opacity: 0.5;
    cursor: not-allowed !important;
    // Block interaction outright while locked so attach/send can't be clicked.
    pointer-events: none;
}
.messages {
    background-color: '#EAEAEA';
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.customShadow:before {
    content: '';
    background-color: transparent;
    width: 100%;
    height: 100%;
    position: absolute;
    pointer-events: none;
    border-radius: 0px 20px 20px 0px;
    .shadow();
}
// The composer box, per the Figma "Input" node: 1px brand border, subtle
// gray-blue fill, 8px radius, shadow-xs. Grows downward with the text; the
// clear/send icons stay pinned to the top line.
.inputBox {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
    padding: 10px;
    background-color: #fcfcfd;
    border: 1px solid #2075f4;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
}

// Auto-growing input via the "replicated content" grid trick: the textarea
// and an invisible ::after mirror share one grid cell; the mirror carries the
// same text (from data-replicated-value) and dictates the height, so the field
// grows one line at a time as text wraps — capped, then it scrolls.
.input {
    flex: 1 0 0;
    min-width: 0;
    display: grid;

    // Both the textarea and the mirror occupy the same cell and MUST share
    // identical type metrics so their line breaks line up.
    &::after,
    textarea {
        grid-area: 1 / 1 / 2 / 2;
        font-size: 14px;
        font-family: 'Hanken Grotesk', sans-serif;
        line-height: 20px;
        letter-spacing: -0.15px;
        padding: 0;
        margin: 0;
        border: none;
        white-space: pre-wrap;
        word-break: break-word;
        overflow-wrap: anywhere;
    }

    // The mirror: same text plus a trailing space so a blank last line still
    // has height. Invisible but takes up space.
    &::after {
        content: attr(data-replicated-value) ' ';
        visibility: hidden;
        max-height: 200px;
    }

    textarea {
        box-sizing: border-box;
        outline: 0;
        background-color: transparent;
        border: none !important;
        width: 100%;
        color: #101828;
        resize: none;
        overflow-y: auto;

        scrollbar-width: thin;
        scrollbar-color: #c0c0c0 transparent;

        &::-webkit-scrollbar {
            width: 6px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: #c0c0c0;
            border-radius: 3px;
        }

        &::placeholder {
            color: #98a2b3;
        }

        // Locked while the approval card is up: greyed and not editable.
        &:disabled {
            cursor: not-allowed;
            color: #98a2b3;
            &::placeholder {
                color: #b8bfca;
            }
        }
    }
}

// Icon buttons living inside the composer box (clear + send).
.iconButton {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    padding: 0;
    background: transparent;
    border: none;
    cursor: pointer;
}
.clearInputButton {
    .iconButton();
    opacity: 0.6;
    transition: opacity 0.2s;
    &:hover {
        opacity: 1;
    }
}
.sendButton {
    .iconButton();
    i {
        color: #2075f4;
        font-size: 18px;
    }
}
.clearIcon {
    width: 20px;
    height: 20px;
}
.sendIcon {
    width: 20px;
    height: 20px;
    display: block;
}

.inputLineOffset {
    display: flex;
    flex-direction: column;
    padding: 16px 24px;
    background-color: #ffffff;
}
